import { render, staticRenderFns } from "./BroadcastsPage.vue?vue&type=template&id=e32a630a&scoped=true"
import script from "./BroadcastsPage.vue?vue&type=script&lang=js"
export * from "./BroadcastsPage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastsPage.vue?vue&type=style&index=0&id=e32a630a&prod&lang=scss&scoped=true"
import style1 from "./BroadcastsPage.vue?vue&type=style&index=1&id=e32a630a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32a630a",
  null
  
)

export default component.exports